import { render, staticRenderFns } from "./BusinessRule.vue?vue&type=template&id=c80439d0&"
import script from "./BusinessRule.vue?vue&type=script&lang=js&"
export * from "./BusinessRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports